import {
  calendar2Icon,
  classIcon,
  locationIcon,
  minusIcon,
  peopleIcon,
  perssonesIcon,
  plusIcon,
  settingIcon,
  filtersIcon,
  volIcon,
  rightarrowIcon,
} from "../../assets/images/icons";

import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Navbar from "../../components/Navbar/Navbar";
import Selectfield from "../../components/Selectfield/Selectfield";
import Topbar from "../../components/Topbar/Topbar";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import "./vols.css";

import Volcard from "../../components/Volcard/Volcard";
import Reservationcard from "../../components/Reservationcard/Reservationcard";
import Partners from "../../components/Partners/Partners";
import Footer from "../../components/Footer/Footer";

function valuetext(value) {
  return `${value} DA`;
}

export default function Vols() {
  const { t } = useTranslation();
  const [enfants, setEnfants] = useState(0);
  const [adults, setAdults] = useState(0);
  const [value, setValue] = useState([10000, 200000]);

  const [isExpanded, setIsExpanded] = useState(false);
  const slideDownHandler = () => {
    setIsExpanded((state) => !state);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className="Pages_vols">
      <Topbar />
      <Navbar page={"vols"}/>
      <div className="main_top">
        <div className="header">
          <div className="el selected">
            <p>{t("vols.tabs.hotels")}</p>
          </div>
          <div className="el">
            <p>{t("vols.tabs.flights")}</p>
          </div>
          <div className="el">
            <p>{t("vols.tabs.organized_trips")}</p>
          </div>
        </div>
        <div className="fields">
          <div className="row">
            <Selectfield
              width={450}
              height={50}
              placeholder={t("vols.search.from_placeholder")}
              icon={locationIcon}
              hiddenDropdownIndicator={true}
              changePlaceHolderStyle={true}
            />
            <Selectfield
              width={450}
              height={50}
              placeholder={t("vols.search.to_placeholder")}
              icon={locationIcon}
              hiddenDropdownIndicator={true}
              changePlaceHolderStyle={true}
            />
            <div className="input1">
              <div className="personnes_input" onClick={slideDownHandler}>
                <img src={perssonesIcon} alt={t("vols.search.persons")} className="icon" />
                <p className="placeholder">{t("vols.search.persons")}</p>
                <img src={settingIcon} alt="settings" className="click_icon" />
              </div>
              <div className={`sliding-div ${isExpanded ? "expanded" : ""}`}>
                <div className="content">
                  <div className="row">
                    <img src={perssonesIcon} className="icon" alt={t("vols.search.adults")} />
                    <p className="title">{t("vols.search.adults")}</p>
                    <div className="perssoneshandler">
                      <img
                        onClick={() => {
                          if (parseInt(adults) > 0) {
                            setAdults((state) => parseInt(state) - 1);
                          }
                        }}
                        src={minusIcon}
                        className={adults === 0 ? "disabled" : ""}
                        alt="minus"
                      />{" "}
                      <p className="title">{adults}</p>
                      <img
                        src={plusIcon}
                        className="plus"
                        alt="plus"
                        onClick={() => {
                          setAdults((state) => parseInt(state) + 1);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <img src={peopleIcon} className="icon" alt={t("vols.search.children")} />
                    <p className="title">{t("vols.search.children")}</p>
                    <p className="faded_text">{t("vols.search.children_age")}</p>
                    <div className="perssoneshandler">
                      <img
                        onClick={() => {
                          if (parseInt(enfants) > 0) {
                            setEnfants((state) => parseInt(state) - 1);
                          }
                        }}
                        src={minusIcon}
                        className={enfants === 0 ? "disabled" : ""}
                        alt="minus"
                      />{" "}
                      <p className="title">{enfants}</p>
                      <img
                        src={plusIcon}
                        className="plus"
                        alt="plus"
                        onClick={() => {
                          setEnfants((state) => parseInt(state) + 1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="input var1">
              <img src={calendar2Icon} alt="calendar" />
              <input
                type="text"
                placeholder={t("vols.search.arrival")}
                name="startDate"
                onFocus={(event) => {
                  event.target.type = "date";
                }}
                onBlur={(event) => {
                  event.target.type = "text";
                }}
              />
            </div>
            <div className="input var1">
              <img src={calendar2Icon} alt="calendar" />
              <input
                type="text"
                name="endDate"
                placeholder={t("vols.search.departure")}
                onFocus={(event) => {
                  event.target.type = "date";
                }}
                onBlur={(event) => {
                  event.target.type = "text";
                }}
              />
            </div>
            <div className="check_container">
              <label>
                <input type="checkbox" />
                <p className="selected"> {t("vols.search.round_trip")} </p>
              </label>
              <label>
                <input type="checkbox" />
                <p> {t("vols.search.one_way")} </p>
              </label>
              <label>
                <input type="checkbox" />
                <p> {t("vols.search.multi_destination")} </p>
              </label>
            </div>
          </div>
          <div className="row">
            {" "}
            <Selectfield
              width={450}
              height={50}
              placeholder={t("vols.search.flight_type")}
              icon={volIcon}
              hiddenDropdownIndicator={false}
              changePlaceHolderStyle={false}
            />
            <Selectfield
              width={450}
              height={50}
              placeholder={t("vols.search.class")}
              icon={classIcon}
              hiddenDropdownIndicator={false}
              changePlaceHolderStyle={false}
            />
            <button className="rechercher">
              <p>{t("vols.search.search_button")}</p>
            </button>
          </div>
        </div>
      </div>
      <div className="p2">
        <div className="left_part">
          <div className="title">
            <p>{t("vols.filters.title")}</p>
            <img src={filtersIcon} alt="filters" />
          </div>
          <div className="label">
            <p>{t("vols.filters.stops")}</p>
            <Selectfield
              width={450}
              height={50}
              placeholder={t("vols.filters.most_recommended")}
              noIcon={true}
              hiddenDropdownIndicator={false}
              changePlaceHolderStyle={true}
            />
          </div>
          <div className="label">
            <p>{t("vols.filters.fare_type")}</p>
            <label>
              <input type="checkbox" />
              <p className="selected"> {t("vols.filters.any")} </p>
            </label>
            <label>
              <input type="checkbox" />
              <p> {t("vols.filters.refundable")} </p>
            </label>
            <label>
              <input type="checkbox" />
              <p> {t("vols.filters.non_refundable")} </p>
            </label>
          </div>
          <div className="label">
            <p>{t("vols.filters.budget")}</p>
            <Box sx={{ width: "270px" }}>
              <Slider
                min={0}
                max={1000000}
                step={100}
                getAriaLabel={() => "Price"}
                value={value}
                onChange={handleChange}
                valueLabelDisplay="auto"
                getAriaValueText={valuetext}
              />
            </Box>
            <div className="range">
              <p>
                <span className="golden_tag">{value[0].toLocaleString()}</span>
              </p>
              <p>-</p>
              <p>
                <span className="blue_tag">{value[1].toLocaleString()}</span>
              </p>
              <p>
                <span className="dark_blue_tag">{t("vols.results.currency")}</span>
              </p>
            </div>
          </div>
          <div className="label">
            <p>{t("vols.filters.airlines")}</p>
            <label>
              <input type="checkbox" />
              <p className="selected"> {t("vols.filters.all")}</p>
            </label>
            <label>
              <input type="checkbox" />
              <p> Air Algerie </p>
            </label>
            <label>
              <input type="checkbox" />
              <p> Air France </p>
            </label>
            <label>
              <input type="checkbox" />
              <p> Turkish Airlines </p>
            </label>
          </div>
        </div>
        <div className="right_part">
          <div className="container_80">
            <div className="top_info">
              <div className="vol">
                <p className="city">Algiers</p>
                <img src={rightarrowIcon} alt="vol" />
                <p className="city">Paris</p>
              </div>
              <p className="details">{t("vols.results.adult_count", { count: 1 })}</p>
              <button>
                <p>{t("vols.results.sort")}</p>
              </button>
            </div>
            <div className="list">
              <div className="el"><Volcard/><Reservationcard remboursement={false}/></div>
              <div className="el"><Volcard/><Reservationcard remboursement={true}/></div>
              <div className="el"><Volcard/><Reservationcard remboursement={false}/></div>
              <div className="el"><Volcard/><Reservationcard remboursement={true}/></div>
              <div className="el"><Volcard/><Reservationcard remboursement={false}/></div>
              <div className="el"><Volcard/><Reservationcard remboursement={true}/></div>
            </div>
          </div>
        </div>
      </div>
      <Partners/>
      <Footer/>
    </div>
  );
}
